import { Component, HostBinding, OnInit } from "@angular/core";

import { SettingsService } from "./core/settings/settings.service";

import { BehaviorSubject } from "rxjs";
import { TourService, TourStepTemplateComponent } from "ngx-ui-tour-md-menu";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { NavigationStart, Router, RouterOutlet } from "@angular/router";
import Swal from "sweetalert2";
import {
  MatCard,
  MatCardTitle,
  MatCardContent,
  MatCardActions,
} from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { UserFacadeService } from "./core/facades/userfacade/userfacade.service";
import { MenuService } from "./core/menu/menu.service";
import { RoleType } from "./core/_models/role";
import { menu, resellermenu, usermenu } from "./routes/menu";
import { DatetimeFormatService } from "./core/datetime-format-service/datetime-format.service";
import { UnleashService } from "./core/api_services/unleash.service";
import { CookiesConsentService } from "./core/cookiesConsentService/cookies-consent.service";
import { NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [
    RouterOutlet,
    TourStepTemplateComponent,
    MatCard,
    MatCardTitle,
    MatCardContent,
    MatCardActions,
    TranslateModule,
    MatButton,
    NgIf,
  ],
})
export class AppComponent implements OnInit {
  @HostBinding("class.layout-fixed") get isFixed() {
    return this.settings.getLayoutSetting("isFixed");
  }
  @HostBinding("class.aside-collapsed") get isCollapsed() {
    return this.settings.getLayoutSetting("isCollapsed");
  }
  @HostBinding("class.layout-boxed") get isBoxed() {
    return this.settings.getLayoutSetting("isBoxed");
  }
  @HostBinding("class.layout-fs") get useFullLayout() {
    return this.settings.getLayoutSetting("useFullLayout");
  }
  @HostBinding("class.hidden-footer") get hiddenFooter() {
    return this.settings.getLayoutSetting("hiddenFooter");
  }
  @HostBinding("class.layout-h") get horizontal() {
    return this.settings.getLayoutSetting("horizontal");
  }
  @HostBinding("class.aside-float") get isFloat() {
    return this.settings.getLayoutSetting("isFloat");
  }
  @HostBinding("class.offsidebar-open") get offsidebarOpen() {
    return this.settings.getLayoutSetting("offsidebarOpen");
  }
  @HostBinding("class.aside-toggled") get asideToggled() {
    return this.settings.getLayoutSetting("asideToggled");
  }
  @HostBinding("class.aside-collapsed-text") get isCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText");
  }
  public role = new BehaviorSubject(undefined);
  public show = false;
  constructor(
    public settings: SettingsService,
    public tourService: TourService,
    public oidcSecurityService: OidcSecurityService,
    private userFacadeService: UserFacadeService,
    private menuService: MenuService,
    private router: Router,
    private dateTimeFormatService: DatetimeFormatService,
    private unleashService: UnleashService,
    private cookiesConsentService: CookiesConsentService,
  ) {}

  endTour = () => {
    this.tourService.end();
  };

  nextTour = () => {
    this.tourService.next();
  };

  ngOnInit() {
    this.userFacadeService.user.subscribe((user) => {
      if (user) {
        if (user.permissions.find((role) => role.value == RoleType.HXAMaster)) {
          this.menuService.addMenu(menu);
        } else if (user.permissions.find((role) => role.value == RoleType.Reseller)) {
          this.menuService.addMenu(resellermenu);
        } else {
          this.menuService.addMenu(usermenu);
        }
        if (user.dateTimeFormat) {
          this.dateTimeFormatService.selectedDateTimeFormat$.next(user.dateTimeFormat);
          this.dateTimeFormatService.isDefault = false;
          this.dateTimeFormatService.saveToStorage();
        }
      }
    });

    // to close any swal modal opened if a user navigated to a different page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        Swal.close(); // Close any active SweetAlert modal
      }
    });
    // prevent empty links to reload the page
    document.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === "A" && ["", "#"].indexOf(target.getAttribute("href")) > -1) {
        e.preventDefault();
      }
    });

    // Check both pathname and hash for public routes (app uses hash location)
    const currentUrl = window.location.hash || window.location.pathname;
    if (currentUrl.includes("/public")) {
      return;
    }

    this.oidcSecurityService.checkAuth().subscribe((r) => {
      if (r.isAuthenticated) {
        const returnUrl = localStorage.getItem("hxa_return_url");
        if (returnUrl) {
          localStorage.removeItem("hxa_return_url");
          this.router.navigateByUrl(returnUrl);
        }
      } else {
        this.oidcSecurityService.authorize();
      }
    });

    // this.tourService.initialize$.subscribe((r) => {});
    // this.tourService.anchorRegister$.subscribe((r) => {});
    // this.tourService.stepShow$.subscribe((step) => {
    //   if (step && step.step && step.step.stepId) {
    //     localStorage.setItem("step", step.step.stepId.toString());
    //   }
    // });
    // this.tourService.pause$.subscribe((r) => {});

    // this.tourService.end$.subscribe(() => {
    // localStorage.setItem("step", "1");
    // console.log("TOUR ENDED");
    // });
    // window.addEventListener("beforeunload", () => {
    // localStorage.removeItem("step");
    // });
    this.unleashService.IntiateUnLeash();
    this.cookiesConsentService.initCookiesConsent();
  }
}
